import { CombinedGraphQLErrors, type ErrorLike } from "@apollo/client";
import type { GraphQLFormattedError } from "graphql";

/**
 * The GraphQL errors behind an Apollo error, or none.
 *
 * Apollo Client 4 removed `ApolloError` and its `graphQLErrors` array. An
 * operation that fails with GraphQL errors now rejects with a single
 * `CombinedGraphQLErrors` carrying them, and anything else — a network failure,
 * a parse failure — is a plain error with no GraphQL errors to report.
 */
export function graphQLErrorsFrom(
	error: ErrorLike | undefined | null,
): readonly GraphQLFormattedError[] {
	if (!error || !CombinedGraphQLErrors.is(error)) {
		return [];
	}

	return error.errors;
}
